import { useEffect, useState, type ReactNode } from 'react';
import { App as AntApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { buildThemeConfig } from './theme';
import { ColorModeProvider, useColorMode } from './colorMode';
import { notificationConfig } from './notificationConfig';
import { i18n } from './i18n';
import { DEFAULT_LANG, isLang, type Lang } from '@/locales/index';
import { AuthProvider } from '@/shared/auth/AuthProvider';
function AntdProviders({ children }: { children: ReactNode }) {
  const { resolved } = useColorMode();
  const [lang, setLang] = useState<Lang>(() =>
    isLang(i18n.language) ? i18n.language : DEFAULT_LANG,
  );
  useEffect(() => {
    const onChanged = (next: string): void => {
      if (isLang(next)) setLang(next);
    };
    i18n.on('languageChanged', onChanged);
    return () => {
      i18n.off('languageChanged', onChanged);
    };
  }, []);
  useEffect(() => {
    dayjs.locale(lang === 'en-US' ? 'en' : 'zh-cn');
  }, [lang]);
  return (
    <ConfigProvider theme={buildThemeConfig(resolved)} locale={lang === 'en-US' ? enUS : zhCN}>
      {}
      {/*
        通知层的全局配置见 `./notificationConfig`：
        - `placement: 'bottomLeft'` —— 通知从**左下角**升起（用户裁定 2026-10-23）：
          右上角留给铃铛与顶栏动作区，通知不遮它们。
        - `maxCount: 4` —— 同时最多四条；再多就淹掉页面了。
        - `styles.root.pointerEvents = 'none'` —— 通知**不拦点击**（左下角的
          toast 会压住「新增订单」弹窗的「创 建」按钮 ⇒ 点不动）。
      */}
      <AntApp notification={notificationConfig}>
        <AuthProvider>{children}</AuthProvider>
      </AntApp>
    </ConfigProvider>
  );
}
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ColorModeProvider>
      <AntdProviders>{children}</AntdProviders>
    </ColorModeProvider>
  );
}
